import * as React from "react";

import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { isEmpty, isTrue } from "../../utils/helpers";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MuiCheckbox from "@material-ui/core/Checkbox";

export const CheckBox = ({ rowIdx, colIdx, column, record, disabled, onChange }) => (
  <MuiCheckbox
    style={{ paddingTop: 0, paddingBottom: 0 }}
    checked={record[column.dataKey]?.checked || false}
    onChange={onChange && onChange({ rowIdx, colIdx, column, record })}
    disabled={typeof disabled === "function" ? disabled({ rowIdx, colIdx, column, record }) : disabled}
  />
);

export const LabeledCheckBox = ({ rowIdx, colIdx, column, record, disabled, onChange }) => (
  <FormControlLabel
    label={isEmpty(record[column.dataKey]?.value) ? "" : `${record[column.dataKey]?.value} ${record.uomCode}`}
    control={
      <MuiCheckbox
        style={{ paddingTop: 0, paddingBottom: 0 }}
        checked={record[column.dataKey]?.checked || false}
        onChange={onChange && onChange({ rowIdx, colIdx, column, record })}
        disabled={typeof disabled === "function" ? disabled({ rowIdx, colIdx, column, record }) : disabled}
      />
    }
  />
);

export const ShadeRowRenderer = ({ classes = {}, rowStyle, cellStyle, columns, record, rowIdx }) => {
  return (
    <TableRow key={rowIdx} style={rowStyle}>
      {columns.map(({ dataKey, align = "left", element, rowSpan, ...rest }, colIdx) => {
        const isTotalRow = isTrue(record.isTotal);
        let cellItem;
        if ((dataKey.startsWith("shade-") || dataKey === "selectAll") && !isTotalRow) {
          if (typeof element === "function") {
            cellItem = element({
              rowIdx,
              colIdx,
              column: { ...rest, dataKey, align },
              record
            });
          } else if (React.isValidElement(element)) {
            cellItem =
              React.isValidElement(element) &&
              React.cloneElement(element, {
                rowIdx,
                colIdx,
                column: { ...rest, dataKey, align },
                record
              });
          } else {
            cellItem = record[dataKey] === null ? "-" : record[dataKey];
          }
        } else {
          cellItem = record[dataKey] === null ? "-" : record[dataKey];
        }

        return (
          <TableCell
            className={classes.rowCell}
            key={colIdx}
            align={align}
            style={cellStyle ? cellStyle({ record, column: { dataKey, align, element, rowSpan, ...rest } }) : {}}>
            {cellItem}
          </TableCell>
        );
      })}
    </TableRow>
  );
};
